export const FILTER_PERIOD = 'relativePeriod';
export const FILTER_APPLICATIONS = 'applications';
export const FILTER_AFFILIATES = 'affiliates';
export const FILTER_CAMPAIGNS = 'campaigns';
export const FILTER_TRAFFIC_TYPE = 'trafficType';
export const FILTER_NETWORKS = 'networks';
export const FILTER_CHANNELS = 'channels';
export const FILTER_OWNERS = 'owners';
export const FILTER_MANAGERS = 'managers';
export const FILTER_PLATFORMS = 'platforms';
export const METRICS = 'metrics';
export const FILTERS = 'filters';

const LAST_7_DAYS = 0;
const TRAFFIC_TYPE_ADVERTISING = 1;
const METRICS_TOTAL_REGS = 'OverallTotalRegs';
const METRICS_TOTAL_SPEND = 'SpentUsd';

export const initialState = {
  [FILTERS]: {
    [FILTER_PERIOD]: LAST_7_DAYS,
    [FILTER_TRAFFIC_TYPE]: TRAFFIC_TYPE_ADVERTISING,
  },
  [METRICS]: [METRICS_TOTAL_REGS, METRICS_TOTAL_SPEND],
};
